import React from "react";
import { Badge, Card, Group, Image, Stack, Text } from "@mantine/core";
import { currencyFormat } from "../../../utils/currencyFormat";

// Vista previa del pack: cursos incluidos y comparación contra comprarlos por separado
function AcademicPackPreview({ values, academicUnitsById }) {
    const info = values.comercialInformation || {};
    const selected = (values.academicUnits || []).map(id => academicUnitsById[id]).filter(Boolean);
    const separatelyUsd = selected.reduce((acc, au) => acc + (au.comercialInformation?.price?.usd || 0), 0);
    const separatelyArs = selected.reduce((acc, au) => acc + (au.comercialInformation?.price?.ars || 0), 0);
    const savingsUsd = Math.max(separatelyUsd - (Number(info.price?.usd) || 0), 0);

    return (
        <Card withBorder radius="md" padding="md" style={{ width: "100%", maxWidth: 520 }}>
            {info.image && (
                <Card.Section>
                    <Image src={info.image} height={180} alt={info.name || "pack"} />
                </Card.Section>
            )}
            <Stack gap={6} mt="sm">
                <Group gap={6}>
                    <Badge>PACK</Badge>
                    <Badge variant="light" color={values.state === "Open" ? "green" : "gray"}>
                        {values.state === "Open" ? "Abierto" : "Cerrado"}
                    </Badge>
                </Group>
                <Text fw={600}>{info.name || "Nombre del pack"}</Text>
                <Text size="sm">USD ${currencyFormat(Number(info.price?.usd) || 0)} · ARS ${currencyFormat(Number(info.price?.ars) || 0)}</Text>
                {selected.length > 0 && (
                    <Text size="xs" c="dimmed">
                        Por separado: USD ${currencyFormat(separatelyUsd)} · ARS ${currencyFormat(separatelyArs)}
                        {savingsUsd > 0 ? ` — ahorro USD $${currencyFormat(savingsUsd)}` : ""}
                    </Text>
                )}
                <Text size="sm" fw={500} mt={4}>Cursos incluidos ({selected.length})</Text>
                {selected.length === 0 && <Text size="xs" c="dimmed">Elegí al menos 2 unidades académicas.</Text>}
                {selected.map(au => (
                    <Text key={au._id} size="xs">• {au.comercialInformation?.name} — USD ${currencyFormat(au.comercialInformation?.price?.usd || 0)}</Text>
                ))}
                {values.studentsCount > 0 && <Text size="xs" c="dimmed" mt={4}>Compradores: {values.studentsCount}</Text>}
            </Stack>
        </Card>
    );
}

export default AcademicPackPreview;
